<script setup>
    import { computed, inject } from 'vue';
    import SubHead from '@/components/result/SubHead.vue';
    import Attainment from '@/components/result/Attainment.vue';
    
    // 부모에서 주입받은 데이터
    const classData = inject('classData');
    const loading = inject('loading');
    
    const pagetype = "literacy";
    const region = "seoul";

    // 문해력 하위 영역 매핑 (API 필드 → 화면 표시명)
    const literacySubCategories = [
        { key: 'korsub1_level', name: '어휘' },
        { key: 'korsub2_level', name: '탐색 및 확인' },
        { key: 'korsub3_level', name: '통합 및 해석' },
        { key: 'korsub4_level', name: '비판 및 평가' }
    ];

    // 하위 영역별 학생 분류 (주의, 경계별 - 테이블 표시용)
    const tableData = computed(() => {
        if (!classData.value || !classData.value.list) {
            return [
                { students: ['', ''] },
                { students: ['', ''] },
                { students: ['', ''] },
                { students: ['', ''] }
            ];
        }

        const data = classData.value;
        
        return literacySubCategories.map(category => {
            const attentionStudents = [];
            const boundaryStudents = [];
            
            data.list.forEach(student => {
                const levelValue = student[category.key];
                
                if (levelValue === '주의') {
                    attentionStudents.push(student.name || '');
                } else if (levelValue === '경계') {
                    boundaryStudents.push(student.name || '');
                }
                // '안전'은 테이블에 표시하지 않음 (명단 생략)
            });
            
            return {
                students: [
                    attentionStudents.join(', '),
                    boundaryStudents.join(', ')
                ]
            };
        });
    });

    // 하위 영역별 통계 데이터 (차트용)
    const statisticsData = computed(() => {
        if (!classData.value || !classData.value.list) {
            console.log('Page3: classData 없음, 기본값 반환');
            return [
                { subcate: '어휘', attentionCount: 0, boundaryCount: 0, safeCount: 0, totalStudents: 0 },
                { subcate: '탐색 및 확인', attentionCount: 0, boundaryCount: 0, safeCount: 0, totalStudents: 0 },
                { subcate: '통합 및 해석', attentionCount: 0, boundaryCount: 0, safeCount: 0, totalStudents: 0 },
                { subcate: '비판 및 평가', attentionCount: 0, boundaryCount: 0, safeCount: 0, totalStudents: 0 }
            ];
        }

        const data = classData.value;
        
        // 문해력 시험을 친 학생들만 계산 (korlevel이 있는 학생)
        const studentsWithKorlevel = data.list.filter(student => student.korlevel !== undefined && student.korlevel !== null);
        const totalStudents = studentsWithKorlevel.length;
        
        console.log('Page3: API 데이터 처리 중:', {
            totalStudents: data.list.length,
            studentsWithKorlevel: totalStudents,
            sampleStudent: data.list[0] // 첫 번째 학생 샘플
        });
        
        const result = literacySubCategories.map(category => {
            let attentionCount = 0;
            let boundaryCount = 0;
            let safeCount = 0;
            
            // 문해력 시험을 친 학생들만 대상으로 계산
            studentsWithKorlevel.forEach(student => {
                const levelValue = student[category.key];
                
                if (levelValue === '주의') {
                    attentionCount++;
                } else if (levelValue === '경계') {
                    boundaryCount++;
                } else if (levelValue === '안전') {
                    safeCount++;
                }
            });
            
            return {
                subcate: category.name,
                attentionCount,
                boundaryCount,
                safeCount,
                totalStudents
            };
        });

        console.log('Page3: 최종 통계 데이터:', result);
        return result;
    });

    // 하위 영역별 수준 데이터 (주요 수준 표시용)
    const subAreaLevels = computed(() => {
        if (!classData.value || !classData.value.list) {
            return ['안전', '안전', '안전', '안전']; // 기본값
        }

        const data = classData.value;
        
        return literacySubCategories.map(category => {
            // 각 영역에서 가장 많은 학생이 속한 수준을 대표 수준으로 표시
            const levelCounts = { '주의': 0, '경계': 0, '안전': 0 };
            
            data.list.forEach(student => {
                const levelValue = student[category.key];
                if (levelCounts[levelValue] !== undefined) {
                    levelCounts[levelValue]++;
                }
            });
            
            // 가장 많은 학생이 속한 수준 반환
            let maxCount = 0;
            let dominantLevel = '안전';
            
            Object.entries(levelCounts).forEach(([level, count]) => {
                if (count > maxCount) {
                    maxCount = count;
                    dominantLevel = level;
                }
            });
            
            return dominantLevel;
        });
    });

</script>
<template>
    <div class="slide-inner">        
        <div class="content">
            <SubHead :type="pagetype" :region="region" title="문해력"/>
            <Attainment 
                :pagetype="pagetype" 
                :tableData="tableData" 
                :statistics="statisticsData" 
                :subAreaLevels="subAreaLevels"
                chartHeight="370px" 
            />           
        </div>
    </div>  
</template>